import type { RadioGroupItemProps } from '@radix-ui/react-radio-group';

import { Indicator, Item } from '@radix-ui/react-radio-group';
import { styled } from 'styled-components';

const ItemSC = styled(Item)`
  all: unset;
  background-color: white;
  width: 25px;
  height: 25px;
  border-radius: 100%;
  border: 2px solid ${(props) => props.theme.colors.slateGray[50]};

  &:hover {
    background-color: rgb(244, 240, 254);
  }

  &:focus {
    border-color: ${(props) => props.theme.colors.emeraldGreen[50]};
  }
`;

const IndicatorSC = styled(Indicator)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  position: relative;

  &::after {
    content: '';
    display: block;
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background-color: ${(props) => props.theme.colors.emeraldGreen[100]};
  }
`;

export function Radio(props: RadioGroupItemProps) {
  return (
    <ItemSC {...props}>
      <IndicatorSC />
    </ItemSC>
  );
}
